import { Box, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  dashboardContainer: {
    paddingTop: theme.spacing(2),
    height: '100%',
    flex: 1,
  },
  emptyState: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    flexDirection: 'column',
    background: 'white',
    borderRadius: 8,
    border: '1px solid #E6E9F0',
  },
  emptyStateText: {
    color: '#9196A6',
    fontSize: 16,
    marginTop: theme.spacing(2),
  },
}));

const ErrorState = () => {
  const classes = useStyles();

  return (
    <Box className={classes.dashboardContainer}>
      <Box className={classes.emptyState}>
        <Typography variant="h6" color="error">
          Ooops!
        </Typography>
        <Typography variant="body2">
          Please try refreshing the page or selecting different filters.
        </Typography>
      </Box>
    </Box>
  );
};

export default ErrorState;
